import { User } from 'api/public/user/types';
import { useTypedSelector } from 'shared/redux/store';
import { selectUser } from '../slice';

export const useAuthUser = (): User | null => {
  const user = useTypedSelector(selectUser);
  // const state = userApi.endpoints.getUserProfile.useQueryState({ token });
  return user;
};
